import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DualListBoxComponent } from './components/dual-list-box/dual-list-box.component';
import { DualListBoxService } from './dual-list-box.service';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ],
  declarations: [DualListBoxComponent],
  exports: [
    DualListBoxComponent
  ],
  providers: [DualListBoxService]
})
export class DualListBoxModule {}



// WEBPACK FOOTER //
// ./src/app/utils/dual-list-box/dual-list-box.module.ts